import { FileData, request } from '@ygtechnologies/bygr-frontend-component-library';
import { PaginatedSearchRequest, PaginationResult, ElectricitySupplierOffer } from 'types';

export function getElectricitySupplierOffers(req: PaginatedSearchRequest): Promise<PaginationResult<ElectricitySupplierOffer>> {
    return request(`api/serviceprovider`, { query: req, method: 'GET' }).then((x) => x.json());
}

export function getElectricitySupplierOffer(id: number): Promise<ElectricitySupplierOffer> {
    return request(`api/serviceprovider/${id}`, { method: 'GET' }).then((x) => x.json());
}

export function updateElectricitySupplierOffer(offer: ElectricitySupplierOffer): Promise<ElectricitySupplierOffer> {
    return request(`api/serviceprovider/${offer.id}`, { body: offer, method: 'PUT', json: true }).then((x) => x.json());
}

export function updateElectricitySupplierOffers(offers: ElectricitySupplierOffer[]) {
    return request(`api/serviceprovider`, { body: offers, method: 'PUT', json: true });
}

export function createElectricitySupplierOffer(offer: ElectricitySupplierOffer): Promise<ElectricitySupplierOffer> {
    return request(`api/serviceprovider`, { body: offer, method: 'POST', json: true}).then((x) => x.json());
}

export function updateLogo(offerId: number, logoFile: FileData): Promise<number> {
    return request(`api/servicerpovider/${offerId}/update-logo`, { body: logoFile, method: 'POST'}).then((x) => x.json());
}

export function deleteElectricitySupplierOffer(id: number) {
    return request(`api/serviceprovider/${id}`, { method: 'DELETE', json: true });
}

export function getOfferLogo(logoId: number): string {
    return `api/serviceprovider/logo/${logoId}`;
}